export default "__VITE_ASSET__sbzARi4H__"